import React from 'react';
import { colors } from 'ui_system/compass';
import IconProps from '../iconTypes';

export const EyeOffIcon: React.FC<IconProps> = ({
  width = '20',
  height = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 22.848"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <g stroke={color} strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(0, -4)">
          <g
            transform="translate(0, 4)"
            fill={colors.text.icon}
            fillRule="nonzero"
          >
            <path d="M31.776,11.296 C31.648,11.072 29.984,7.744 26.304,5.088 L31.488,1.376 L30.528,0 L24.8,4.096 C22.656,2.848 20,1.92 16.768,1.792 C16.576,1.792 16.384,1.76 16.16,1.76 C16.128,1.76 16.096,1.76 16.064,1.76 C16.032,1.76 16,1.76 15.968,1.76 C4.96,1.76 0.384,10.88 0.192,11.264 L0,11.616 L0.192,11.968 C0.288,12.192 1.856,15.328 5.312,17.952 L0.48,21.472 L1.44,22.848 L6.784,19.04 C9.152,20.48 12.16,21.568 16,21.568 C16.032,21.568 16.064,21.568 16.096,21.568 C16.128,21.568 16.16,21.568 16.192,21.568 C16.384,21.568 16.608,21.568 16.8,21.536 C27.072,21.12 31.616,12.448 31.808,12.064 L32,11.68 L31.776,11.296 Z M24.352,11.648 C24.352,16 20.928,19.584 16.64,19.84 C16.448,19.84 16.256,19.84 16.096,19.84 C13.568,19.808 11.328,18.656 9.824,16.832 L13.12,14.496 C13.888,15.264 14.976,15.744 16.16,15.744 C18.56,15.744 20.48,13.792 20.48,11.424 C20.48,10.752 20.32,10.112 20.032,9.536 L23.104,7.328 C23.904,8.608 24.352,10.08 24.352,11.648 Z M19.04,8.224 C18.272,7.552 17.28,7.104 16.16,7.104 C13.792,7.104 11.84,9.024 11.84,11.424 C11.84,12.032 11.968,12.576 12.192,13.12 L8.896,15.456 C8.32,14.304 7.968,13.024 7.968,11.648 C7.968,7.168 11.616,3.488 16.096,3.456 C16.288,3.456 16.48,3.456 16.64,3.456 C18.784,3.584 20.704,4.544 22.112,6.016 L19.04,8.224 Z M1.92,11.68 C2.56,10.592 4.736,7.264 8.736,5.216 C7.2,6.944 6.304,9.184 6.304,11.648 C6.304,13.376 6.752,15.008 7.552,16.416 L6.784,16.96 C3.968,15.008 2.432,12.608 1.92,11.68 Z M8.48,17.824 C8.576,17.952 8.704,18.08 8.8,18.208 C8.64,18.112 8.48,18.048 8.32,17.952 L8.48,17.824 Z M23.904,17.76 C25.248,16.064 26.048,13.952 26.048,11.648 C26.048,9.696 25.472,7.904 24.512,6.368 L24.896,6.112 C27.904,8.128 29.568,10.688 30.112,11.648 C29.472,12.704 27.488,15.712 23.904,17.76 Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};
